import { render, staticRenderFns } from "./NewDateFields.vue?vue&type=template&id=39cafa07&scoped=true&"
import script from "./NewDateFields.vue?vue&type=script&lang=js&"
export * from "./NewDateFields.vue?vue&type=script&lang=js&"
import style0 from "./NewDateFields.vue?vue&type=style&index=0&id=39cafa07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cafa07",
  null
  
)

export default component.exports